const URL_API = 'https://gestaosaude.xbrain.com.br/api';
export default URL_API;